import request from "./request";

/**获取商品详情 
 * 
*/
export async function getShangPingList(pay_type = '', shangpu_no = "", shangping_no = '') {
  return await request.get(`https://biz.xinmin.cn/index/shangping/detail.shtml?pay_type=${pay_type}&shangpu_no=${shangpu_no}&shangping_no=${shangping_no}`)
}

/**下单接口
 * @param {String} pay_type       支付类型:weixin，ali，H5
 * @param {String} shangping_no   商品编号
 * @param {String} shangpu_no     商铺编号
 * @param {Number} count          数量
 * @param {Number} total          总金额
 * @param {String} user_name      姓名
 * @param {String} user_address   投递地址
 * @param {String} user_phone     电话
 * @param {String} province       省  可选
 * @param {String} city           市区
*/
export async function pay(postInfo) {
  return await request.post(`https://biz.xinmin.cn/index/order/add.shtml`, postInfo)
}